import React from 'react';

import ClientiConfirm from './clientiConfirm';

function UtentiTable(props) {
  return (
    <div>
      {/* <ClientiConfirm setClick={(click) => (this.clickChild = click)} /> */}
      {/* <button onClick={() => this.boh()}>Click</button> */}
      <table
        id='clienti'
        className='table table-striped table-bordered table-hover'
      >
        <thead>
          <tr>
            <th>Id</th>
            <th>Cliente Id</th>
            <th>Nome</th>
            <th>Cognome</th>
            <th>Email</th>
            <th>Telefono</th>
            <th>Data </th>
            <th>zz</th>

            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {/* <tr key={k} onClick={() => props.VisRecord(k)}> */}
          {props.clienti.map((cliente, k) => (
            <tr key={k}>
              <td onClick={() => props.VisRecord(k)}>{k}</td>
              <td onClick={() => props.VisRecord(k)}>{cliente.id}</td>
              <td onClick={() => props.VisRecord(k)}>{cliente.nome}</td>
              <td onClick={() => props.VisRecord(k)}>{cliente.cognome}</td>
              <td onClick={() => props.VisRecord(k)}>{cliente.email}</td>
              <td onClick={() => props.VisRecord(k)}>{cliente.telefono}</td>
              <td onClick={() => props.VisRecord(k)}>{cliente.datar}</td>

              <td onClick={() => props.VisRecord(k)}>{cliente.nome}</td>
              <td>
                <button
                  className='btn btn-warning table-buttons'
                  onClick={() => props.modifica(cliente.id, k)}
                >
                  <i className='fa fa-edit' aria-hidden='true'></i> Modifica
                </button>
              </td>
              <td>
                <button
                  className='btn btn-warning table-buttons'
                  //onClick={() => Annulla(k)}
                  //onClick={() => Elimina1(k)}
                  onClick={() => props.Elimina(k)}
                  // onClick={() => this.click}
                  // setClick={(click) => (this.clickChild = click)}

                  //per passare un parametro bisogna creare una arrowfunc
                  //cosi non viene eseguita in fase di render
                >
                  <i className='fa fa-minus' aria-hidden='true'></i> Elimina
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UtentiTable;
